import React from 'react';
import I18n from 'i18n-js';
import className from 'classnames';
import { CommonsMParticleListing } from '../schemas/rql';
import withMParticleListings from '@reverbdotcom/commons/src/components/with_mparticle_listings';
import { destroy, post } from './api_request';
import Location from '../lib/wrapped_location';
import { WatchParentComponentName, WatchParentComponentNames } from '@reverbdotcom/commons/src/event_tracking/watchlist';

import {
  ProductActionType,
  MParticleEventName,
  trackEvent,
} from '@reverbdotcom/commons/src/elog/mparticle_tracker';

interface IProps {
  listingIds: string[];
  cartItemId: string;
  canMoveToWatchList?: boolean;
  canRemoveFromCart?: boolean;
  mParticleListings?: CommonsMParticleListing.Listings[];
}

function track(
  listing: CommonsMParticleListing.Listings,
  productActionType: ProductActionType,
  eventName: MParticleEventName,
  source: string,
  componentName?: WatchParentComponentName | string,
): void {
  if (!listing) return;

  trackEvent({
    listing,
    productActionType,
    eventName,
    source,
    componentName,
  });
}

function trackRemoveFromCartClick(
  listing: CommonsMParticleListing.Listings,
): void {
  if (!listing) return;

  trackEvent({
    eventName: MParticleEventName.ClickedRemoveFromCart,
    listing,
  });
}

export function CartItemActions(props: IProps) {
  const {
    listingIds,
    cartItemId,
    canMoveToWatchList,
    canRemoveFromCart,
    mParticleListings,
  } = props;

  const listingId = listingIds[0];
  const listings = mParticleListings || [];
  const listing = listings[0];

  function moveToWatchList() {
    post(`/cart/${cartItemId}/move_to_watchlist`, {}, {}, '3.0').then(() => {
      track(listing, ProductActionType.AddToWishlist, MParticleEventName.AddToWishlist, 'addToWishlist', WatchParentComponentNames.Cart);
      track(listing, ProductActionType.RemoveFromCart, MParticleEventName.RemoveFromCart, 'removeFromCart');
      Location.reload();
    });
  }

  function removeFromCart() {
    destroy(`/cart/${listingId}`, {}, {}, '3.0').then(() => {
      track(listing, ProductActionType.RemoveFromCart, MParticleEventName.RemoveFromCart, 'removeFromCart');
      Location.reload();
    });
  }

  function handleRemoveFromCartClick() {
    trackRemoveFromCartClick(listing);
    removeFromCart();
  }

  const watchButtonClasses = className(
    'mr-space',
    'fa',
    'fa-star',
  );

  return (
    <ul className="inline-list mt-half small">
      {canMoveToWatchList && (
        <li className="margined-right hidden-mobile">
          <button
            className="color-gray button-as-link"
            data-move-to-watchlist
            onClick={moveToWatchList}
            type="button"
          >
            <span className={watchButtonClasses} />
            {I18n.t('discovery.removeFromCart.moveToWatchList')}
          </button>
        </li>
      )}
      {canRemoveFromCart && (
        <li>
          <button
            className="color-gray button-as-link"
            data-toggle-confirmation
            onClick={() => handleRemoveFromCartClick()}
          >
            <span className="fa fa-times mr-space" />
            {I18n.t('discovery.removeFromCart.remove')}
          </button>
        </li>
      )}
    </ul>
  );
}

export default withMParticleListings<IProps>()(CartItemActions);
